<!--
  语言切换组件 - 支持中/英切换，后续可扩展其他语言
-->
<template>
  <el-dropdown trigger="click" @command="handleCommand" placement="bottom">
    <span class="language-switcher el-dropdown-link">
      <svg
        class="lang-icon"
        viewBox="0 0 24 24"
        width="18"
        height="18"
      >
        <path
          fill="currentColor"
          d="M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.66h11.17c-.29 1.92-.88 3.75-1.71 5.38C8.5 10.66 6.5 11.5 4 11.5v2c2.5 0 4.5-.83 6.5-2.17 1.17 1.87 2.5 3.5 4 4.74V22h2v-2.5c1.5-.74 2.83-2.87 4-4.74 1.17 1.87 2.5 3.5 4 4.74V22h2v-2.5c-1.5-.74-2.83-2.87-4-4.74-1.17 1.87-2.5 3.5-4 4.74V22h-2v-2.5c-1.5-.74-2.83-2.87-4-4.74-1.17 1.87-2.5 3.5-4 4.74V22H1v-2.5h.5c1.5-.74 2.83-2.87 4-4.74 1.17 1.87 2.5 3.5 4 4.74V22h2v-2.5c1.5-.74 2.83-2.87 4-4.74z"
        />
      </svg>
      <span class="lang-text">{{ currentLabel }}</span>
      <i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item
        v-for="item in localeOptions"
        :key="item.value"
        :command="item.value"
        :class="{ 'is-active': currentLocale === item.value }"
      >
        {{ item.label }}
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import { SUPPORTED_LOCALES, setLocale, getLocale } from '@/i18n'

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      localeOptions: SUPPORTED_LOCALES
    }
  },
  computed: {
    currentLocale() {
      return getLocale()
    },
    currentLabel() {
      const item = this.localeOptions.find(l => l.value === this.currentLocale)
      return item ? item.label : this.currentLocale
    }
  },
  methods: {
    handleCommand(locale) {
      if (locale === this.currentLocale) return
      setLocale(locale)
      this.$message.success(this.$t('app.success'))
      // 刷新页面以应用 Element UI 等组件的语言
      this.$nextTick(() => {
        window.location.reload()
      })
      // this.$forceUpdate();
    }
  }
}
</script>

<style lang="scss" scoped>
.language-switcher {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  padding: 0 8px;
  color: #fff;

  .lang-icon {
    margin-right: 4px;
    opacity: 0.9;
  }

  .lang-text {
    font-size: 14px;
    margin-right: 2px;
  }

  &:hover {
    opacity: 0.9;
  }
}

.el-dropdown-menu__item.is-active {
  color: #409eff;
  font-weight: 500;
}
</style>
